import en from "./en.json";
import si from "./si.json";

export default {
  en: { translation: en },
  si: { translation: si },
};
